import { NovastarHSeriesBase } from './util/NovastarHSeriesBase';
export class NovastarHSeriesTcp extends NovastarHSeriesBase {
    constructor(socket, log) {
        super(log);
        this.socket = socket;
        this.log = log;
        this.commandExtractor = {
            terminators: ['\r'],
        };
        this.sendTerminator = '\r';
    }
    send(response) {
        this.socket.send(response);
    }
}
NovastarHSeriesTcp.emulatorType = 'socketEmulator';
NovastarHSeriesTcp.key = '-NJ6nAHqPslQfVu9XvGs';
